import { AnimatePresence, motion } from 'framer-motion';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import { Advt } from './components/Advt/Advt';
import Message from './components/Message/Message';
// import { Winners } from './components/Winners/Winners';

function App() {
  const { currentState, currentMessage, stateCarousel, winnerMessages } =
    useBroadcast();
  const { duration } = useGetParams();

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className="motionBlock"
            key={`advt-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Advt />
          </motion.div>
        )}
        {currentState === stateCarousel && (
          <motion.div
            className="motionBlock"
            key={`msg-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Message
              currentMessage={currentMessage}
              message={currentMessage?.message}
              duration={duration}
            />
          </motion.div>
        )}
        {/* 
        {currentState === 'S3' && (
          <motion.div
            key={`win-${currentState}`}
            className="motionBlock"
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Winners winnerMessages={winnerMessages} />
          </motion.div>
        )} */}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
